var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFindReplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C8.38 2 9.63 2.56 10.54 3.46L8.85 5.15C8.54 5.46 8.76 6 9.21 6H13.5C13.78 6 14 5.78 14 5.5V1.21C14 0.76 13.46 0.54 13.15 0.86L11.95 2.06C10.68 0.78 8.93 0 7 0C3.96 0 1.38 1.94 0.42 4.64C0.18 5.3 0.65 6 1.35 6C1.77 6 2.14 5.74 2.28 5.34C2.96 3.4 4.82 2 7 2ZM12.64 11.14C13.04 10.6 13.36 9.99 13.59 9.34C13.82 8.69 13.34 8 12.65 8C12.23 8 11.86 8.26 11.72 8.66C11.04 10.6 9.18 12 7 12C5.62 12 4.37 11.44 3.46 10.54L5.15 8.85C5.46 8.54 5.24 8 4.79 8H0.5C0.22 8 0 8.22 0 8.5V12.79C0 13.24 0.54 13.46 0.85 13.14L2.05 11.94C3.32 13.22 5.07 14 7 14C8.55 14 9.98 13.49 11.14 12.64L15.25 16.75C15.66 17.16 16.33 17.16 16.74 16.75C17.15 16.34 17.15 15.67 16.74 15.26L12.64 11.14Z",
    fill: "#B1B1B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindReplace);
export default __webpack_public_path__ + "static/media/find_replace.3eab1232.svg";
export { ForwardRef as ReactComponent };